import Home from "../pages/Home"

const routes = [
  {
    path: ["/", "/home"],
    exact: true,
    component: "Home",
    test: Home
  },
];

export default routes;
